import AnalyticsEvent from './AnalyticsEvent';
import AnalyticsService from './AnalyticsService';
import { AnalyticsEventBeforeLoggedIn } from './constant';

class AnalyticsManager extends AnalyticsService {
  private static _instance: AnalyticsManager;

  private services = Array<AnalyticsService>();
  public platform = String();
  public session_id = String();

  private constructor() {
    super();
  }

  private setProperties = (
    event: AnalyticsEvent,
    properties: Record<string, unknown> | undefined,
    platform: string,
    session_id: string,
  ) => {
    if (!platform) return properties;

    let env: string;
    let screen_width: number | null;
    let screen_height: number | null;
    const isEventBeforeLogin = AnalyticsEventBeforeLoggedIn.includes(event);

    try {
      env = JSON.parse(localStorage.getItem('env') ?? '');
    } catch {
      env = '';
    }

    try {
      screen_width = window.innerWidth;
      screen_height = window.innerHeight;
    } catch {
      screen_width = null;
      screen_height = null;
    }

    const defaultProperties = {
      platform,
      screen_height,
      screen_width,
    };

    const loggedInProperties = {
      ...defaultProperties,
      session_id,
      env,
    };

    if (isEventBeforeLogin) return { ...properties, ...defaultProperties };
    if (properties) return { ...properties, ...loggedInProperties };
    return { ...loggedInProperties };
  };

  static instance(): AnalyticsManager {
    if (!AnalyticsManager._instance) {
      AnalyticsManager._instance = new AnalyticsManager();
    }

    return AnalyticsManager._instance;
  }

  setUserId(userId: string): void {
    this.services.forEach(service => {
      service.setUserId(userId);
    });
  }

  setUserProperties(properties: Record<string, unknown>): void {
    this.services.forEach(service => {
      service.setUserProperties(properties);
    });
  }

  track(event: AnalyticsEvent, properties?: Record<string, unknown>): void {
    this.services.forEach(service => {
      if (service.shouldTrack(event)) {
        const eventByPlatform = this.setProperties(
          event,
          properties,
          this.platform,
          this.session_id,
        );
        service.track(event, eventByPlatform);
      }
    });
  }

  register(service: AnalyticsService) {
    this.services.push(service);
  }

  setPlatform(platform: string) {
    this.platform = platform;
  }

  setSessionId(session_id: string) {
    this.session_id = session_id;
  }
}

export default AnalyticsManager;
